import Encounters from './Encounters';

export default Encounters;
